import { useTranslate } from "@refinedev/core";
import { PanelSection } from "../PanelSection";
import { useTemplatesStatusStore } from "../../../store/useTemplatesStatusStore";
import { useTemplateEditorStore } from "../../../store/useTemplateEditorStore";
import { Flex } from "antd";
import { ITEM_TYPES, SHAPE_TYPES, ShapeType } from "../../../types";
import { ShapeButton } from "./features/ShapeButton";
import { generateNewShape } from "./helpers";
import { useChangeLayer } from "../../../hooks/useChangeLayer";
import { ShapeControls } from "./ShapeControls";

export const ShapesTab = ({
  previewWidth,
  previewHeight,
  addToSlideLayout = false,
  newShapeNamePrefix = "shape",
}: {
  previewWidth: number;
  previewHeight: number;
  addToSlideLayout?: boolean;
  newShapeNamePrefix?: string;
}) => {
  const t = useTranslate();

  const { addShape, addSlideLayoutShape, currentItem } = useTemplateEditorStore(
    (store) => ({
      addShape: store.addShape,
      addSlideLayoutShape: store.addSlideLayoutShape,
      currentItem: store.templateState.currentItem,
    })
  );

  const { addTemplateUpdate } = useTemplatesStatusStore((state) => ({
    addTemplateUpdate: state.addTemplateUpdate,
  }));

  const { newHighestLayerIndex } = useChangeLayer();

  const isShapeSelected = currentItem?.type === ITEM_TYPES.Shape;

  const handleAddShape = (shapeType: ShapeType) => {
    const newShape = generateNewShape(
      shapeType,
      previewWidth,
      previewHeight,
      newHighestLayerIndex,
      newShapeNamePrefix
    );
    if (addToSlideLayout) {
      addSlideLayoutShape(newShape);
    } else {
      addShape(newShape);
    }
    addTemplateUpdate();
  };

  return (
    <>
      <PanelSection
        title={t("components.templates.settings.shapesTab.tabTitle")}
        subtitle={t("components.templates.settings.shapesTab.description")}
        primary
      >
        <Flex gap={16} wrap="wrap">
          {Object.values(SHAPE_TYPES).map((shapeType) => (
            <ShapeButton
              key={shapeType}
              onClick={handleAddShape}
              shapeType={shapeType}
            />
          ))}
        </Flex>
      </PanelSection>
      {isShapeSelected && (
        <ShapeControls
          previewWidth={previewWidth}
          previewHeight={previewHeight}
        />
      )}
    </>
  );
};
